import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { PointConfig } from '@src/types/PointConfig';

export default () =>
  useApiQuery<PointConfig[]>({
    queryKey: [QueryKeys.pointConfigs],
    apiPath: '/point-configs',
    method: 'GET',
    useV2API: true,
  });
